// extracted by mini-css-extract-plugin
export var createdDate = "_nr-1";
export var divider = "_nr-2";
export var headerDivider = "_nr-3";
export var messagesCard = "_nr-0";
export var messagesContainer = "_nr-6";
export var messagesContainerWrapper = "_nr-4";
export var showLeftPanelButton = "_nr-8";
export var topButtons = "_nr-7";
export var withPadding = "_nr-5";